import React, { useContext, useLayoutEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useMeasure, useWindowSize } from 'react-use';
import ThemeContext from '../../contexts/themeContext';
import Button from '../../components/bootstrap/Button';
import Portal from '../Portal/Portal';
import useDarkMode from '../../hooks/useDarkMode';
import { SubHeaderCenter } from '../SubHeader/SubHeader';
import { removeItem } from '../../lib/localstorage';
import { useNavigate } from 'react-router-dom';
import { useMst } from '../../models';
import Icon from '../../components/icon/Icon';
import { Link } from 'react-router-dom';

export const HeaderLeft = ({ children, className }) => {
	return <div className={classNames('header-left', 'col-md', className)}>{children}</div>;
};
HeaderLeft.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
HeaderLeft.defaultProps = {
	className: null,
};

export const HeaderRight = ({ children, className }) => {
	const [ref, { height }] = useMeasure();

	const root = document.documentElement;
	root.style.setProperty('--header-right-height', `${height}px`);

	return (
		<div ref={ref} className={classNames('header-right', 'col-md-auto', className)}>
			{children}
		</div>
	);
};
HeaderRight.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
HeaderRight.defaultProps = {
	className: null,
};

const Header = ({ children, hasLeftMobileMenu, hasRightMobileMenu }) => {
	const { themeStatus } = useDarkMode();

	const windowsWidth = useWindowSize().width;
	const [refMobileHeader, sizeMobileHeader] = useMeasure();
	const [refHeader, sizeHeader] = useMeasure();

	const root = document.documentElement;
	root.style.setProperty('--mobile-header-height', `${sizeMobileHeader.height}px`);
	root.style.setProperty('--header-height', `${sizeHeader.height}px`);

	const navigate = useNavigate();
	const { user, config } = useMst()
	const isSelected = (menu) => {
		return location.pathname === menu ? 'font' : ''
	}


	const {
		asideStatus,
		setAsideStatus,
		leftMenuStatus,
		setLeftMenuStatus,
		rightMenuStatus,
		setRightMenuStatus,
		asideSubStatus,
		setAsideSubStatus,
	} = useContext(ThemeContext);

	useLayoutEffect(() => {
		if (
			(asideStatus || leftMenuStatus || rightMenuStatus) &&
			windowsWidth < process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE
		)
			document.body.classList.add('overflow-hidden');
		return () => {
			document.body.classList.remove('overflow-hidden');
		};
	});

	return (
		<>
			<header ref={refMobileHeader} className='mobile-header'>
				<div className='d-flex flex-row justify-content-between text-center w-100 p-3'>
					<Link to={'/'} className={isSelected('/')}>
						<Icon icon='Grade' fontSize={28} color="light" className={'me-1 ' + isSelected('/')} />
						<div>지음과깃듬</div>
					</Link>
					<Link to={'/home'} className={isSelected('/home')}>
						<Icon icon='Home' fontSize={28} color="light" className={'me-1 ' + isSelected('/home')} />
						<div>Home</div>
					</Link>
					<Link to={'/icru'} className={isSelected('/icru')}>
						<Icon icon='Image' fontSize={28} color="light" className={'me-1 ' + isSelected('/icru')} />
						<div>ICRU</div>
					</Link>
					<Link to={'/test'} className={isSelected('/test')}>
						<Icon icon='PendingActions' fontSize={28} color="light" className={'me-1 ' + isSelected('/test')} />
						<div>진단</div>
					</Link>
					{!user?.id &&
						<Link
							className={isSelected('/login')}
							onClick={() => {
								config.setPrevPage('/')
								navigate('/login')
							}}
						>
							<Icon icon='Login' fontSize={28} color="light" className={'me-1 ' + isSelected('/login')} />
							<div>로그인</div>
						</Link>}
					{user?.id > 0 &&
						<Link 
							className={isSelected('/mypage')}
							shadow={'lg'}
							isLink={true}
							color="success"
							onClick={() => {
								// navigate('/mypage')
							}}
						>
							<Icon icon='AccountCircle' fontSize={28} color="light" className={'me-1 ' + isSelected('/mypage')} />
							<div>{user.name}</div>
						</Link>}
					{!user?.id &&
						<Link 
							className={isSelected('/signup')}
							onClick={() => navigate('/signup')}
						>
							<Icon icon='PersonAdd' fontSize={28} color="light" className={'me-1 ' + isSelected('/signup')} />
							<div>회원가입</div>
						</Link>}
					{user?.id > 0 &&
						<Link 
							className={isSelected('/logout')}
							onClick={() => {
								removeItem('access-token')
								removeItem('refresh-token')
								user.logout()
								navigate('/')
							}}
						>
							<Icon icon='Logout' fontSize={28} color="light" className={'me-1 ' + isSelected('/logout')} />
							<div>로그아웃</div>
						</Link>}
				</div>
			</header>
			<header
				ref={refHeader}
				className={classNames('header', {
					'header-left-open': leftMenuStatus,
					'header-right-open': rightMenuStatus,
				})}>
				<div className='container-fluid'>
					<div className='row d-flex align-items-center'>
						{children}
						{(leftMenuStatus || rightMenuStatus) && (
							<Portal>
								<div
									role='presentation'
									className={classNames('header-overlay', {
										'header-overlay-left-menu': leftMenuStatus,
										'header-overlay-right-menu': rightMenuStatus,
									})}
									onClick={() => {
										setAsideStatus(false);
										setAsideSubStatus(false);
										setLeftMenuStatus(false);
										setRightMenuStatus(false);
									}}
								/>
							</Portal>
						)}
					</div>
				</div>
			</header>
		</>
	);
};
Header.propTypes = {
	children: PropTypes.node.isRequired,
	hasLeftMobileMenu: PropTypes.bool,
	hasRightMobileMenu: PropTypes.bool,
};
Header.defaultProps = {
	hasLeftMobileMenu: true,
	hasRightMobileMenu: true,
};

export default Header;
